module.exports = __webpack_public_path__ + "static/media/spring-protection.f81be5fe.jpeg";